import { Box } from "@chakra-ui/react";
import { ReactElement } from "react";

export function VideoBackground(): ReactElement {
  // TODO: Final implementation still TBD, maybe we'll end up with something lighter. Video disabled for now.
  return (
    <Box
      zIndex="-1"
      position="absolute"
      top="0"
      right="0"
      bottom="0"
      left="0"
      overflow="hidden"
      background="black"
    >
      {/* <video autoPlay muted loop id="myVideo" width="100%" height="100%">
        <source src="partner_program_background_resized.mp4" type="video/mp4" />
      </video> */}
      <Box
        position="absolute"
        top="0"
        right="0"
        bottom="0"
        left="0"
        background="#1A1B31"
        opacity="0.8"
        blendMode="multiply"
      />
    </Box>
  );
}
